import { formatDaysSince, formatScore } from './scoreFormat.ts';

export interface ScoreBreakdownProps {
  llmScore: number;
  boost: number;
  freshnessFactor: number;
  finalScore: number;
  daysSinceLastUsed: number | null;
}

/**
 * The arithmetic behind a recommendation score, written out.
 *
 * The whole point of both recommendation screens is trusting the ranking, and a
 * single number cannot be argued with — this is the line that can.
 */
export function ScoreBreakdown({
  llmScore,
  boost,
  freshnessFactor,
  finalScore,
  daysSinceLastUsed,
}: ScoreBreakdownProps) {
  return (
    <p className='mt-2 border-t border-line pt-2 font-mono text-xs text-ink-muted'>
      LLM {llmScore} × boost {formatScore(boost)} × freshness{' '}
      {formatScore(freshnessFactor)}
      {' = '}
      {formatScore(finalScore, 1)}
      <span className='ml-2'>(last used: {formatDaysSince(daysSinceLastUsed)})</span>
    </p>
  );
}
